<template>
    <div class="invoice">
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="开票申请号" label-width="100px">
                        <el-input v-model="searchForm.applicationNo" placeholder="账单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="发票申请时间">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                        :picker-options="pickerOptions" clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="开票状态" label-width="70px">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="申请中" value="0"></el-option>
                            <el-option label="已开票" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="结算状态" label-width="70px">
                        <el-select v-model="searchForm.settlStatus" placeholder="状态" size="mini" clearable style="width: 150px">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未结算" value="0"></el-option>
                            <el-option label="已结算" value="1"></el-option>
                            <el-option label="结算中" value="2"></el-option>
                            <el-option label="结算异常" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%"
                    :height="tableConfig.height"
                    :span-method="spanMethod"
                    :cell-style="cellStyle"
                    size="mini"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column prop="applicationNo" label="开票申请号" width="130" />
                    <el-table-column prop="currentBatch" label="当前批次号" width="80"/>
                    <el-table-column prop="currentOrderNum" label="当前批次子订单总数" width="80"/>
                    <el-table-column label="当前批次不含税总金额" align="center" width="300">
                        <el-table-column prop="currentBatchNakedAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformCurrentBatchNakedAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column label="当前批次含税总金额" align="center" width="300">
                        <el-table-column prop="currentBatchAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformCurrentBatchAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column prop="totalBatch" label="总批次数" width="80"/>
                    <el-table-column prop="totalOrderNum" label="总批次的子订单总数" width="80"/>
                    <el-table-column label="总批次的不含税总金额" align="center" width="300">
                        <el-table-column prop="totalBatchNakedAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformTotalBatchNakedAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column label="总批次的含税总金额" align="center" width="300">
                        <el-table-column prop="totalBatchAmount" align="center" label="京采" width="150" />
                        <el-table-column prop="platformTotalBatchAmount" align="center" label="平台" width="150" />
                    </el-table-column>
                    <el-table-column prop="status" label="开票状态" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0" size="mini">申请中</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 1" size="mini">已开票</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="结算状态" width="80">
                        <template slot-scope="scope">
                            <el-tag type="info" v-if="scope.row.settlStatus == 0" size="mini">未结算</el-tag>
                            <el-tag type="success" v-if="scope.row.settlStatus == 1" size="mini">已结算</el-tag>
                            <el-tag v-if="scope.row.settlStatus == 2" size="mini">结算中</el-tag>
                            <el-tag type="warning" v-if="scope.row.settlStatus == 3" size="mini">结算异常</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="发票申请时间" min-width="200"/>
                    <el-table-column prop="opt" label="操作" width="250" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToOrder(scope.row)">订单</el-button>
                            <el-button type="text" size="mini" @click="handleShowInvoice(scope.row)">发票</el-button>
                            <el-button type="text" size="mini" @click="handleShowConsignee(scope.row)">收票人</el-button>
                            <el-button type="text" size="mini" @click="handleShowinvoiceForm(scope.row)">发票回执</el-button>
                            <!-- <el-button :disabled="scope.row.settlStatus != 0" type="text" size="mini" @click="handleSettlement(scope.row)">结算</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background layout="sizes, prev, pager, next" v-if="total>0" :total="total"
                                    :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange"
                                    @current-change="onPageChange" @prev-click="onPageChange" @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="申请开票信息" :visible.sync="invoiceDialogVisible"  :close-on-click-modal="false">
            <div class="invoiceForm">
                <el-row class="invoiceRow">
                    <el-col style="text-align: right" :span="2">发票类型 :</el-col>
                    <el-col style="padding-left: 16px" :span="6">{{selectedInvoice.invoiceType == 1 ? '增值税普通发票' : '增值税专用发票'}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">发票抬头 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.invoiceTitle}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">发票内容 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.content == 1 ? '明细' : '大类'}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">纳税人识别号 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.itins}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">开户银行 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.bank}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">银行账户 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.account}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">注册地址 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.address}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">注册电话 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedInvoice.telephone}}</el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog title="开票收票人信息" :visible.sync="consigneeDialogVisible"  :close-on-click-modal="false">
            <div class="invoiceForm">
                <el-row class="invoiceRow">
                    <el-col style="text-align: right" :span="2">收票人姓名 :</el-col>
                    <el-col style="padding-left: 16px" :span="6">{{selectedConsignee.name}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">收票人手机号 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.mobile}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">省级 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.province}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">市级 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.city}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">县区 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.county}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">乡镇 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.town}}</el-col>
                </el-row>
                <el-row class="invoiceRow">
                    <el-col class="invoiceTitleCol" :span="2">详细地址 :</el-col>
                    <el-col class="invoiceContentCol" :span="6">{{selectedConsignee.address}}</el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog title="开票回执" :visible.sync="editInvReceiptVisible"  :close-on-click-modal="false">
            <el-form ref="frm" :model="receiptForm" :rules="rules" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="开票申请号：" label-width="130px">
                            <div>{{receiptForm.applicationNo}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票材质：" prop="invoiceMaterial" label-width="130px">
                            <el-select :disabled="receiptForm.status == 1" v-model="receiptForm.invoiceMaterial" placeholder="请选择" size="mini" clearable style="width: 150px">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="电子票" value="1"></el-option>
                                <el-option label="纸质发票" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发票类型：" label-width="140px">
                            <div>{{receiptForm.invoiceType == 1 ? '增值税普通发票' : '增值税专用发票'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票抬头：" label-width="140px">
                            <div>{{receiptForm.invoiceTitle}}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发票总金额：" label-width="140px">
                            <div>{{receiptForm.invoiceAmount}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票未税金额：" label-width="140px">
                            <div>{{receiptForm.invoiceNakedAmount}}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发票税率：" label-width="140px">
                            <div>{{receiptForm.invoiceTaxRate}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票张数" prop="invoiceNum" label-width="140px">
                            <el-input-number :min="1" :step="1" v-model="receiptForm.invoiceNum" placeholder="请填写发票张数" :disabled="receiptForm.status == 1"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="电子票下载地址：" prop="fileUrl" label-width="140px">
                            <el-upload
                                class="avatar-uploader"
                                ref="upload"
                                action="/api/admin/uploadInvoice"
                                name="file"
                                accept=".pdf"
                                :limit="1"
                                :show-file-list="true"
                                :file-list="fileList"
                                :on-exceed="onExceed"
                                :before-upload="beforeUpload"
                                :on-preview="handlePreview"
                                :on-success="handleSuccess"
                                :on-remove="handleRemove">
                                <el-button size="small" type="primary" >点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="请填写发票代码：" prop="invoiceCode" label-width="140px">
                            <el-input placeholder="请填写发票代码" v-model="receiptForm.invoiceCode" :disabled="receiptForm.status == 1" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票号码：" prop="invoiceId" label-width="140px">
                            <el-input placeholder="请填写发票号码" v-model="receiptForm.invoiceId" :disabled="receiptForm.status == 1" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="开票内容：" prop="invoiceContent" label-width="140px">
                            <el-input placeholder="请填写开票内容" v-model="receiptForm.invoiceContent" type="textarea" :rows="4" :disabled="receiptForm.status == 1" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="开票机构名称：" prop="billOrg" label-width="140px">
                            <el-input placeholder="请填写开票机构名称" v-model="receiptForm.billOrg" :disabled="receiptForm.status == 1" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="纳税人识别号：" prop="taxpayer" label-width="140px">
                            <el-input placeholder="请填写纳税人识别号" v-model="receiptForm.taxpayer" :disabled="receiptForm.status == 1" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="电子票下载地址：" prop="fileUrl" label-width="140px">
                            <el-upload
                                class="avatar-uploader"
                                ref="upload"
                                action="/api/admin/upload"
                                name="file"
                                accept=".jpg,.png,.pdf"
                                :limit="1"
                                :show-file-list="true"
                                :file-list="fileList"
                                :on-exceed="onExceed"
                                :before-upload="beforeUpload"
                                :on-preview="handlePreview"
                                :on-success="handleSuccess"
                                :on-remove="handleRemove">
                                <el-button size="small" type="primary" :disabled="receiptForm.status == 1">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过10MB</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editInvReceiptVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit" :disabled="receiptForm.status == 1">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const HEIGHT_OFFSET = 118;
export default {
    name: "Invoice",
    data() {
        let validateInvoice = (rule, value, callback) => {
            if(this.receiptForm.invoiceType == 2 && value === ""){
                callback(new Error('请填写纳税人识别号'))
            }else {
                callback()
            }
        }
        let validateFileUrl = (rule, value, callback) => {
            if(this.receiptForm.invoiceMaterial == 1 && value === ""){
                callback(new Error('请填写电子票下载地址'))
            }else {
                callback()
            }
        }
        return {
            searchForm: {
                applicationNo: "",
                status: "",
                settlStatus: "",
                timeDate: "",
            },
            tableConfig: {
                height: 0,
            },
            searchFormStash: {},
            selectData: [],
            loading: false,
            total: 0,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            currentPage: 1,
            tableData: [],
            // 合并规则对象
            mergeObj: {},
            // 合并的列
            mergeCol: ['applicationNo', 'totalBatch', 'totalBatchNakedAmount', 'platformTotalBatchNakedAmount','totalBatchAmount','platformTotalBatchAmount','totalOrderNum','status',"opt"],

            invoiceDialogVisible: false,
            selectedInvoice: {},

            consigneeDialogVisible: false,
            selectedConsignee: {},

            editInvReceiptVisible: false,
            fileList: [],
            receiptForm: {
                applicationNo: '',
                invoiceNum: '1',
                invoiceType: '',
                invoiceId: '',
                invoiceCode: '',
                invoiceContent: '',
                invoiceNakedAmount: '',
                invoiceAmount: '',
                invoiceTitle: '',
                invoiceTaxRate: '0.13',
                taxpayer: '',
                invoiceMaterial:'1',
                fileUrl: '',
                billOrg: '',
                paymentCode:'',
                status: '',
            },
            rules: {
                invoiceId: [{ required: true, message: '请填写发票号码', trigger: 'blur' }],
                invoiceCode: [{ required: true, message: '请填写发票代码', trigger: 'blur' }],
                invoiceContent: [{ required: true, message: '请填写开票内容', trigger: 'blur' }],
                invoiceMaterial: [{ required: true, message: '请选择发票材质', trigger: 'blur' }],
                billOrg: [{ required: true, message: '请填写开票机构名称', trigger: 'blur' }],
                taxpayer: [{ validator: validateInvoice, trigger: 'blur'}],
                fileUrl: [{ validator: validateFileUrl, trigger: 'blur'}],

            },
        }

    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.onSearch();
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    methods: {
        onSearch() {
            this.selectData = [];
            let cond = { ...this.searchForm };
            if (!this.searchForm.status) {
                cond['status'] = undefined;
            }
            if (this.searchForm.timeDate != "" && this.searchForm.timeDate != null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.searchFormStash = {...cond};
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/jcy/settlement/invoicelist", {
                cond: cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                    _this.getSpanArr(_this.tableData);
                }
            }).catch(function () {
                this.loading = false;
            });
        },
        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        onSubmit() {
            let _this = this;
            this.$refs.frm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/jcy/settlement/invReceipt", this.receiptForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header && resp.header.status == 0) {
                                _this.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                _this.editInvReceiptVisible = false;
                                _this.receiptForm.invoiceType = "";
                                _this.receiptForm.invoiceId = "";
                                _this.receiptForm.invoiceCode = "";
                                _this.receiptForm.invoiceContent = "";
                                _this.receiptForm.billOrg = "";
                                _this.receiptForm.taxpayer = "";
                                _this.receiptForm.fileUrl = "";
                                _this.receiptForm.status = "";
                                this.onSearch();
                            } else {
                                _this.$notify.error({
                                    title: '错误',
                                    message: resp.resultMsg
                                });
                            }
                        });
                }
            })
        },
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() > Date.now();
            },
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        handleToOrder(row) {
            this.$router.push({
                name: "jcyorder", query: {billId:row.billId}, params:{title:"订单列表"}
            });
        },
        handleShowInvoice(row) {
            this.selectedInvoice = JSON.parse(row.invoiceInfo);
            this.invoiceDialogVisible = true;
        },
        handleShowConsignee(row) {
            this.selectedConsignee = JSON.parse(row.receiverInfo);
            this.consigneeDialogVisible = true;
        },
        handleShowinvoiceForm(row) {
            if(row.status == 0) {
                let invoiceInfo = JSON.parse(row.invoiceInfo)
                this.receiptForm.applicationNo = row.applicationNo;
                this.receiptForm.nvoiceType = invoiceInfo.invoiceType;
                this.receiptForm.invoiceNakedAmount = row.totalBatchNakedAmount;
                this.receiptForm.invoiceAmount = row.totalBatchAmount;
                this.receiptForm.invoiceTitle = invoiceInfo.invoiceTitle;
                this.receiptForm.status = row.status;

                this.editInvReceiptVisible = true;
            }else{
                let _this = this;
                this.$axios.get(`/admin/jcy/settlement/getInvReceipt/${row.applicationNo}`).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        _this.receiptForm = resp.data;
                        _this.receiptForm.invoiceMaterial = `${row.invoiceMaterial}`;
                        _this.receiptForm.status = row.status;
                        _this.editInvReceiptVisible = true;
                    }
                });
            }
        },
        handleSettlement(row) {
            let _this = this;
            this.$confirm('确认打款信息完成后，发起结算。', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.get(`/admin/jcy/settlement/settledNotice/${row.applicationNo}`).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        row.settlStatus == 2
                    }
                });
            })
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        cellStyle ({row, column, rowIndex, columnIndex}){
            if(column.property == "platformCurrentBatchNakedAmount" || column.property == "currentBatchNakedAmount") {
                if(row.platformCurrentBatchNakedAmount != row.currentBatchNakedAmount){
                    return "color: #e6a23c"
                }
            }

            if(column.property == "platformCurrentBatchAmount" || column.property == "currentBatchAmount") {
                if(row.platformCurrentBatchAmount != row.currentBatchAmount){
                    return "color: #e6a23c"
                }
            }

            if(column.property == "platformTotalBatchNakedAmount" || column.property == "totalBatchNakedAmount") {
                if(row.platformTotalBatchNakedAmount != row.totalBatchNakedAmount){
                    return "color: #e6a23c"
                }
            }

            if(column.property == "platformTotalBatchAmount" || column.property == "totalBatchAmount") {
                if(row.platformTotalBatchAmount != row.totalBatchAmount){
                    return "color: #e6a23c"
                }
            }
        },
        spanMethod ({ row, column, rowIndex, columnIndex }) {
            // // 判断列的属性
            if (this.mergeCol.indexOf(column.property) !== -1) {
                if(this.mergeObj[rowIndex]) {
                    // 如果当前行需要合并
                    return [this.mergeObj[rowIndex], 1];
                } else {
                    // 如果当前行不需要合并
                    return [0, 0];
                }
                // 判断其值是不是为0
                // if (this.mergeObj[column.property][rowIndex]) {
                //     // console.log(column.property + "----" +this.mergeObj[column.property][rowIndex])
                //     return [this.mergeObj["applicationNo"][rowIndex], 1]
                // } else {
                //     return [0, 0]
                // }
            }
        },
        getSpanArr (list) {
            let startLine = [];
            let oldKey = "";
            // 找到不同applicationNo的起始行
            list.forEach((item, index) => {
                if(item.applicationNo != oldKey) {
                    startLine.push(index);
                    oldKey = item.applicationNo;
                }
            });
            startLine.forEach((item, index) => {
                if(index < startLine.length - 1) {
                    this.mergeObj[item] = startLine[index + 1] - item;
                } else {
                    this.mergeObj[item] = list.length - item;
                }
            });
            // let key = "applicationNo"
            // this.mergeCol.forEach((key) => {
            //     let count = 0 // 用来记录需要合并行的起始位置
            //     this.mergeObj[key] = [] // 记录每一列的合并信息
            //     list.forEach((item, index) => {
            //         // index == 0表示数据为第一行，直接 push 一个 1
            //         if (index === 0) {
            //             this.mergeObj[key].push(1)
            //         } else {
            //             // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
            //             if (item[key] === list[index - 1][key]) {
            //                 this.mergeObj[key][count] += 1
            //                 this.mergeObj[key].push(0)
            //             } else {
            //                 // 如果当前行和上一行其值不相等
            //                 count = index // 记录当前位置
            //                 this.mergeObj[key].push(1) // 重新push 一个 1
            //             }
            //         }
            //     })
            // })
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        //文件上传成功的钩子函数
        handleSuccess(res, file) {
            if (file.response.data.success) {
                this.$message({
                    type: 'info',
                    message: '发票上传成功',
                    duration: 6000
                });
                this.receiptForm.fileUrl = file.response.data.url; //将返回的文件储存路径赋值picture字段
                this.receiptForm.invoiceId = file.response.data.invoiceId; //将返回的发票号码赋值invoiceId字段
                this.receiptForm.billOrg = file.response.data.billOrg; //将返回的开票机构名称赋值billOrg字段
                this.receiptForm.taxpayer = file.response.data.taxpayer; //将返回的纳税人识别号赋值taxpayer字段
                this.receiptForm.invoiceContent = file.response.data.invoiceContent; //将返回的开票内容赋值invoiceContent字段
            } else {
                this.$message({
                    type: 'info',
                    message: '发票上传失败',
                    duration: 6000
                });
            }
        },
        //删除文件之前的钩子函数
        handleRemove() {
            this.receiptForm.fileUrl = "";
            this.$message({
                type: 'info',
                message: '已删除原有发票',
                duration: 6000
            });
        },
        //点击列表中已上传的文件事的钩子函数
        handlePreview() {
        },
        //上传的文件个数超出设定时触发的函数
        onExceed() {
        },
        //文件上传前的前的钩子函数
        //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';
            const isLt10M = file.size / 1024 / 1024 < 10;

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传文件必须是JPG/PNG/PDF 格式!');
            }
            if (!isLt10M) {
                this.$message.error('上传图片大小不能超过 10MB!');
            }
            return (isJPG || isPNG || isPDF) && isLt10M;
        },
    }
}
</script>

<style>
.invoiceForm {
    padding-left: 20px;

    .invoiceRow {
        padding-bottom: 10px;
    }
    .invoiceTitleCol {
        text-align: right
    }
    .invoiceContentCol {
        padding-left: 16px
    }
}
</style>
